import axios from "axios";

export const cashRegisterApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/cash-register`,
  headers: {
    "Content-Type": "application/json",
  },
});
